import * as React from "react";

import styles from "./critical.scss";

export const Tabs = ({ children }) => (
  <div className={styles.tabsContainer}>
    <div className={styles.tabs}>{children}</div>
  </div>
);
